import { QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from '../authentication/authContext';
import { PopupProvider } from '../components/confirmation';
import { ErrorBoundary } from '../components/errorBoundary';
import { AppSidebarProvider } from '../components/sidebar/appSidebarProvider';
import { queryClient } from '../lib/react-query';
export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppSidebarProvider className="h-full min-h-0 flex-col">
            <PopupProvider>{children}</PopupProvider>
          </AppSidebarProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};
